import { render, staticRenderFns } from "./VueFormAttribute.vue?vue&type=template&id=1b9949d8"
import script from "./VueFormAttribute.vue?vue&type=script&lang=ts"
export * from "./VueFormAttribute.vue?vue&type=script&lang=ts"
import style0 from "./VueFormAttribute.vue?vue&type=style&index=0&id=1b9949d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports